import { cn } from '@/lib/utils';

interface MarkProps {
  className?: string;
  /** sem tile (só wordmark) — usado em footer/email. Default false */
  noTile?: boolean;
}

export function Mark({ className, noTile = false }: MarkProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2.5 font-sans font-bold text-[18px] tracking-[-0.02em] text-fg',
        className,
      )}
    >
      {!noTile && (
        <span
          aria-hidden
          className={cn(
            'grid h-11 w-11 place-items-center rounded-[16px]',
            'bg-[linear-gradient(160deg,var(--ink-soft),var(--ink))]',
            'text-mint-deep',
            'shadow-[inset_0_1px_0_rgba(255,255,255,0.10),inset_0_-2px_4px_rgba(0,0,0,0.18),0_6px_14px_-6px_rgba(20,16,8,0.45)]',
            'dark:bg-[linear-gradient(160deg,var(--mint-deep),#5c9a7e)] dark:text-on-mint',
          )}
        >
          {/* Glyph G — brand mark (docs/design-handoff-v2/project/brand/marks/glyph-g.svg) */}
          <svg
            width="26"
            height="26"
            viewBox="0 0 64 64"
            fill="none"
            stroke="currentColor"
            strokeWidth="5.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M52 24a18 18 0 1 0 0 16M52 32H42" />
            <circle cx="42" cy="32" r="3.5" fill="currentColor" stroke="none" />
          </svg>
        </span>
      )}
      <span className="inline-flex items-baseline gap-px">
        Gest<span className="text-mint-deep">AKI</span>
      </span>
    </span>
  );
}
